module.exports = __webpack_public_path__ + "netflix.png";